export default __webpack_public_path__ + "static/media/reglogin-bg-bm.8eeed607.webp";